/** MIN & MAX of ads selected for Ads Comparison page*/
export const MIN_ADS_COMPARISON = 2;
export const MAX_ADS_COMPARISON = 5;
